export const ASYNC_FETCH_REMOVE_PLAN = 'ASYNC_FETCH_REMOVE_PLAN';
export const ASYNC_FETCH_REMOVE_PLAN_SUCCESS = 'ASYNC_FETCH_REMOVE_PLAN_SUCCESS';
export const ASYNC_FETCH_REMOVE_PLAN_FAILURE = 'ASYNC_FETCH_REMOVE_PLAN_FAILURE';
export const ASYNC_FETCH_REMOVE_PLAN_INVALIDATE = 'ASYNC_FETCH_REMOVE_PLAN_INVALIDATE';
export const SUBMIT_PLANS_DATA = 'SUBMIT_PLANS_DATA';
export const SET_FLOW_TYPE_RP = 'RP_FLOW_TYPE';


export const ASYNC_FETCH_RP_ED = 'RP_EffectiveDate/ASYNC_FETCH';
export const ASYNC_FETCH_SUCCESS_RP_ED = 'RP_EffectiveDate/ASYNC_FETCH_SUCCESS';
export const ASYNC_FETCH_FAILURE_RP_ED = 'RP_EffectiveDate/ASYNC_FETCH_FAILURE';
export const ASYNC_FETCH_INVALIDATE_RP_ED = 'RP_EffectiveDate/ASYNC_FETCH_INVALIDATE';
export const SET_SELECTED_EFFECTIVE_DATE_RP_ED = 'RP_EffectiveDate/SET_SELECTED_EFFECTIVE_DATE';

export const ASYNC_FETCH_RP_RV = 'RP_Review/ASYNC_FETCH';
export const ASYNC_FETCH_SUCCESS_RP_RV = 'RP_Review/ASYNC_FETCH_SUCCESS';
export const ASYNC_FETCH_FAILURE_RP_RV = 'RP_Review/ASYNC_FETCH_FAILURE';
export const ASYNC_FETCH_INVALIDATE_RP_RV = 'RP_Review/ASYNC_FETCH_INVALIDATE';
export const SET_REVIEW_DATA_RP_RV = 'RP_Review/SET_REVIEW_DATA';
export const SET_ISREVIEW_LOAD = 'RP_Review/SET_ISREVIEW_LOAD';

export const ASYNC_FETCH_RP_Confirm = 'RP_Confirm/ASYNC_FETCH';
export const ASYNC_FETCH_SUCCESS_RP_Confirm = 'RP_Confirm/ASYNC_FETCH_SUCCESS';
export const ASYNC_FETCH_FAILURE_RP_Confirm = 'RP_Confirm/ASYNC_FETCH_FAILURE';
export const ASYNC_FETCH_INVALIDATE_RP_Confirm = 'RP_Confirm/ASYNC_FETCH_INVALIDATE';
export const SET_REVIEW_DATA_RP_Confirm = 'RP_Confirm/SET_REVIEW_DATA';
export const SET_ISCONFIRM_LOAD = 'RP_Confirm/SET_ISCONFIRM_LOAD';

/**
 * action types
 * @type {string}
 */

 export const formatPhoneNumber = (val) => { // eslint-disable-line
    if (val !== '') {
      return val.substring(0, 3) + '.' + val.substring(3, 6) + '.' + val.substring(6);
    }
    return val;
  };

  // export const formatDate = (val) => {
  //   const value = new Date(val);
  //   let dd = value.getDate();
  //   let mm = value.getMonth() + 1; // January is 0!
  //   const yyyy = value.getFullYear();
  //   if (dd < 10) {
  //     dd = '0' + dd;
  //   }
  //   if (mm < 10) {
  //     mm = '0' + mm;
  //   }
  
  //   return mm + '/' + dd + '/' + yyyy;
  // };
  